<template>
  <div class="footer-bigbox">
    <div class="footer-box">
      <div class="footer-right">
        <div class="foo">
          <p>友情链接</p>
          <i><a target="_Blank" href="https://www.nmpa.gov.cn/">国家药品监督管理局</a></i>
          <i><a target="_Blank" href="https://mpa.shaanxi.gov.cn/">陕西省药品监督管理局</a></i>
        </div>
        <div class="foo">
          <p>产品</p>
          <!-- <i>数字化运营系统</i>
          <i>领医未来</i>
          <i>专业化药房</i>
          <i>K7领客</i>
          <i>医智诺就医助手</i> -->
          <i><a  @click="routerJump('/product')">苁蓉-数字化运营平台</a></i>
          <i><a  @click="routerJump('/projectApp')">领医未来</a></i>
          <i><a  @click="routerJump('/productPatient')">医智诺就医助手</a></i>
          <i><a  @click="routerJump('/productPharmacy')">专业化药房</a></i>
          <!-- <div>数字化运营系统</div>
          <div>领医未来</div>
          <div>专业化药房</div>
          <div>K7领客</div>
          <div>医智诺就医助手</div> -->
        </div>
        <div class="foo">
          <p>解决方案</p>
          <!-- @click="routerJump('/app/1')" -->
          <i><a  @click="routerJump('/operationSolution')">数字化运营解决方案</a></i>
          <i><a  @click="routerJump('/projectSolution')">数字化项目管理解决方案</a></i>
          <i><a  @click="routerJump('/ecologicalSolution')">数字化运营生态解决方案</a></i>
        </div>
        <div class="foo">
          <p>新闻中心</p>
          <i><a  @click="routerJump('/companyNews')">医智诺新闻动态</a></i>
          <i><a  @click="routerJump('/industryNews')">医疗行业动态</a></i>
        </div>
        <div class="foo">
          <p>关于我们</p>
          <i><a  @click="routerJump('/aboutUs')">集团介绍</a></i>
          <i><a  @click="routerJump('/culture')">企业文化</a></i>
          <i><a  @click="routerJump('/contact')">联系我们</a></i>
          <!-- <i><a  @click="routerJump('/brand')">"医智诺"品牌</a></i> -->
        </div>
        <div class="foo">
          <p>加入我们</p>
          <i><a  @click="routerJump(`/joinUs?showPoster=${ Date.now() }`)">校园招聘</a></i>
          <i><a  @click="routerJump('/socialRecruit')">社会招聘</a></i>
        </div>
        <div class="foo">
          <div class="attention">
            <img src="../../assets/image/code.png" alt="">
          </div>
          <div class="txt">微 信 关 注 我 们</div>
        </div>
      </div>
    </div>
    <div class="content-backups">
      <div class="content-backups-info" style="margin-bottom:15px;">
        <div class="two-sides" style="margin:5px 0px; letter-spacing: 1px;">
          <span>陕西省西安市高新区天谷八路156号 西安软件新城研发基地二期C2栋14层1401室</span>
           <!-- <div style="margin:0px">
            备案号：
            <a class="footer-icp" href="https://beian.miit.gov.cn" target="_blank">陕ICP备18017834号-1</a> |
            <span class="footer-icp" @click="combineDialogVisible = true">合字 B2-20230471</span>
          </div> -->
        </div>
        <!-- <div class="two-sides" style="letter-spacing: 1px;"> -->

          <div style="letter-spacing: 1px;">
            <a class="footer-icp" href="https://beian.miit.gov.cn" target="_blank">陕ICP备18017834号-1</a>
            <span class="space">|</span> 
            <span class="footer-icp" @click="combineDialogVisible = true">增值电信业务经营许可证</span>
            <span class="space">|</span> 
            <span class="footer-icp" @click="certDialogVisible = true">互联网药品医疗器械信息服务备案凭证</span>
            <span class="space">|</span> 
            <span class="footer-icp" @click="recordDialogVisible = true">医疗器械网络交易服务第三方平台备案凭证</span>
            <span class="space">|</span> 
            <span class="footer-icp" @click="drugThirdDialogVisible = true">药品网络交易第三方平台备案信息</span>
          </div>
          <!-- <div style="margin:0px">
            备案编号：
            <span class="footer-icp" @click="recordDialogVisible = true">(陕)网械平台备字〔2019〕第00002号</span> |
            <span class="footer-icp" @click="drugThirdDialogVisible = true">(陕)网药平台备字〔2025〕第000007-000号</span>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
    <el-dialog
      :visible.sync="recordDialogVisible"
      top="15vh"
      append-to-body
      width="500px">
      <div class="record-info">
        <img src="@/assets/image/certification/recordNumber.png" alt="陕网药信备字">
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="certDialogVisible"
      top="15vh"
      append-to-body
      width="500px">
      <div class="record-info">
        <img src="@/assets/image/certification/drug_cert.png" alt="互联网药品信息服务备案凭证编号">
      </div>
    </el-dialog>
     <el-dialog
      :visible.sync="combineDialogVisible"
      top="15vh"
      append-to-body
      width="900px"
      >
      <div class="record-info">
        <img src="@/assets/image/certification/telecommunications.png" alt="增值电信业务经营许可证">
      </div>
    </el-dialog>
    
     <el-dialog :visible.sync="drugThirdDialogVisible" top="15vh" append-to-body width="600px">
      <div class="record-info">
        <img src="@/assets/image/certification/drugThirdFiling.png" alt="药品网络交易第三方平台备案信息">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../../assets/styles/footer.scss";
import "../../assets/styles/public.scss";
export default {
  data() {
    return {
      recordDialogVisible: false,
      certDialogVisible: false,
      combineDialogVisible: false,
      drugThirdDialogVisible: false,
    };
  },
  methods: {
    routerJump(m) {
      if(this.$route.path === m) {
        this.$router.go(0)
      } else {
        this.$router.push({ path: m });
        this.$store.commit("changeActiveMenu", m);
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="scss"  scoped>
  .footer-right {
    a {
      cursor: pointer;
    }
    a:hover{
      color: rgba(13, 110, 253, 0.9);
    }
    width: auto; // 缩小了间距 整体居中，还原则删除掉
  }
  .footer-icp{
    color: inherit;
    cursor: pointer;
    &:hover{
      color: rgba(13, 110, 253, 0.9);
    }
  }
  .record-info {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .two-sides{
    display: flex;
    justify-content: space-between;
  }
.space{
  margin: 0 13px;
}
</style>
